
import React, { useEffect, useState } from "react";

// Chakra imports
import {
  Box,
  Flex,
  Grid,
  Text,
  useColorModeValue,
  SimpleGrid,
} from "@chakra-ui/react";

// Custom components
import Banner from "views/admin/dashboard/components/Banner";
import TableTopCreators from "views/admin/dashboard/components/TableTopCreators";
import Indicator from "components/card/Indicator";
import Card from "components/card/Card.js";

// Assets
import Nft1 from "assets/img/nfts/Nft1.png";
import Nft5 from "assets/img/nfts/Nft5.png";
import Nft6 from "assets/img/nfts/Nft6.png";

import { tableColumnsTopCreators } from "views/admin/dashboard/variables/tableColumnsTopCreators";
import useDashboardService from "services/dashboardService";
import useEnterpriseService from "services/enterpriseService";


export default function Dashboard() {
  // Chakra Color Mode
  const [ activity, setActivity ] = useState([])
  const [kpiData, setKpiData] = useState();
  const { getActivity } = useDashboardService()
  const { getEnterpriseKPIs } = useEnterpriseService();

  const getData = async () => {
    const activityData  = await getActivity()
    const kpiData = await getEnterpriseKPIs();
    if (activityData) {
      setActivity(activityData)
    } 
    if (kpiData) {
      setKpiData(kpiData)
    }

  }

  useEffect(()=>{
    getData()
  },[])
  const textColor = useColorModeValue("secondaryGray.900", "white");




  return (
    <Box pt={{ base: "180px", md: "80px", xl: "80px" }}>
      {/* Main Fields */}
      <Grid
      mt='10px'
        mb='20px'
        gridTemplateColumns={{ xl: "repeat(3, 1fr)", "2xl": "1fr 0.46fr" }}
        gap={{ base: "30px", xl: "30px" }}
        display={{ base: "block", xl: "grid" }}>
        <Flex
          flexDirection='column'
          gridArea={{ xl: "1 / 1 / 2 / 3", "2xl": "1 / 1 / 2 / 2" }}>
          <Banner />
          <Flex direction='column'>
            <Flex
              mt='55px'
              mb='12px'
              justifyContent='space-between'
              direction={{ base: "column", md: "row" }}
              align={{ base: "start", md: "center" }}>
              <Text color={textColor} fontSize='2xl' ms='24px' fontWeight='700'>
                Indicateurs Clés
              </Text>
            </Flex>
            <SimpleGrid columns={{ base: 1, md: 3 }} gap='30px'>
              <Indicator
                name='Managers actifs'
                author='sur les 15 derniers jours'
                image={Nft1}
                value= {kpiData ? kpiData.activeManagers.toString()+ " / "+ kpiData.totalManagers.toString(): 'N/A'}
              />
              <Indicator
                name='Mesure moyenne'
                author="de l'ensemble de groupe"
                image={Nft5}
                value= {kpiData ? kpiData.globalAverageScore : 'N/A'}
              />
              <Indicator
                name='# Scénarios'
                author='moyenne du groupe'
                image={Nft6}
                value= {kpiData ? kpiData.averageScenariosPerManager.toString() : 'N/A'}
              />
            </SimpleGrid>
          </Flex>
        </Flex>
        <Flex
          flexDirection='column'
          gridArea={{ xl: "1 / 3 / 2 / 4", "2xl": "1 / 2 / 2 / 3" }}>
          <Card px='0px' mb='0px'>
            <TableTopCreators
              tableData={activity}
              columnsData={tableColumnsTopCreators}
            />
          </Card>
          
        </Flex>
      </Grid>
      {/* Delete Product */}
    </Box>
  );
}
